import styled from 'styled-components';
import FlexItem from './FlexItem';
import { media } from '../media';

export const Wrapper = styled.div`
  padding: 3em 0 1em;

  @media print {
    padding: 0;
  }
`;

export const Main = FlexItem.withComponent('main').extend`
  flex: 0 0 ${(7/12) * 100}%;
  width: ${(7/12) * 100}%;

  ${media.tablet`
    flex-basis: 100%;
    width: 100%;
  `};

  @media print {
    flex-basis: 100%;
    width: 100%;
  }
`;

export const Aside = FlexItem.withComponent('aside').extend`
  flex: 0 0 ${(3/12) * 100}%;
  width: ${(3/12) * 100}%;

  &:empty {
    display: none;
  }

  ${media.tablet`
    flex-basis: 100%;
    width: 100%;
  `};

  @media print {
    flex-basis: 100%;
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/core/layout/components/core.js